import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class ProductThumbsSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
            prevNextButtons: true,
            pageDots: false,
            autoplay: true,
            wrapAround: true,
            cellAlign: "left",
            cellSelector: ".product-images__thumbnails-item",
		};

		if (this.$el.length) {
			this._init();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.product-images__thumbnails-item');
        this.slidesCount = this.$slides.length;

        // console.log('Nombre de miniatures produit: ' + this.slidesCount);
        
        if (document.body.clientWidth < 391 && this.slidesCount > 3) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider mobile SM - plus de 3 slides');
        } else if (document.body.clientWidth >= 391 && document.body.clientWidth < 495 && this.slidesCount > 4) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider mobile - plus de 4 slides');
        } else if (document.body.clientWidth >= 495 && document.body.clientWidth < 598 && this.slidesCount > 5) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider mobile XL - plus de 5 slides');
        } else if (document.body.clientWidth >= 598 && document.body.clientWidth < 702 && this.slidesCount > 6) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider tablette SM - plus de 6 slides');
        } else if (document.body.clientWidth >= 702 && document.body.clientWidth < 769 && this.slidesCount > 7) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider tablette SM - plus de 7 slides');
        } else {
            // console.log('no product thumbnails slider');
        } 
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if (document.body.clientWidth < 391 && this.slidesCount > 3) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Resize - slider mobile SM - plus de 3 slides', this.slidesCount);
        } else if (document.body.clientWidth >= 391 && document.body.clientWidth < 495 && this.slidesCount > 4) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Resize - slider mobile - plus de 4 slides', this.slidesCount);
        } else if (document.body.clientWidth >= 495 && document.body.clientWidth < 598 && this.slidesCount > 5) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Resize - slider mobile XL - plus de 5 slides', this.slidesCount);
        } else if (document.body.clientWidth >= 598 && document.body.clientWidth < 702 && this.slidesCount > 6) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Resize - slider tablette SM - plus de 6 slides', this.slidesCount);
        } else if (document.body.clientWidth >= 702 && document.body.clientWidth < 769 && this.slidesCount > 7) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Resize - slider tablette SM - plus de 7 slides', this.slidesCount);
        } else {
            this._destroy();
            // console.log('Resize - no product thumbnails slider', this.slidesCount);
        }
    }

}

export default ProductThumbsSlider;
